import { Component } from '@angular/core';
import * as UserRoleActions from '@app/modules/user-roles/actions/user-role-api.actions';
import * as UserRole from '@app/modules/user-roles/reducers';
import { ClaimTypes, ClaimValues } from '@app/shared/models/common/constants';
import { Store } from '@ngrx/store';
import { NzTableQueryParams } from 'ng-zorro-antd/table';

@Component({
	selector: 'app-user-role-overview',
	templateUrl: './user-role-overview.component.html',
	styleUrls: ['./user-role-overview.component.less'],
})
export class UserRoleOverviewComponent {
	tableData$ = this.store.select(UserRole.selectUserRoleOverviewState);

	ClaimTypes = ClaimTypes;
    ClaimValues = ClaimValues;

	constructor(private readonly store: Store) {}

	onDeleteConfirm(id: string): void {
		this.store.dispatch(UserRoleActions.Delete({ id: id }));
	}

	/**
	 * Trigger the loading of data whenever the table changes.
	 * The default pageSize, index and sort options are based on the TableStateModel.
	 * @param params
	 */
	onQueryParamsChange(params: NzTableQueryParams) {
		const { pageSize, pageIndex, sort, filter } = params;
		const currentSort = sort.find((item) => item.value !== null);
		const sortField = (currentSort?.key) ?? null;
		const sortOrder = (currentSort?.value) ?? null;

		this.store.dispatch(
			UserRoleActions.FilterOverview({
				pagination: {
					page: pageIndex,
					pageSize,
				},
				sorting: {
					propertyName: sortField ?? '',
					order: !!sortField ? (sortOrder === 'ascend' ? 'ASC' : 'DESC') : '',
				},
			})
		);
	}
}
